import * as React from 'react'
import {useEffect} from 'react'
import Modal from 'antd/lib/modal'
import 'antd/lib/modal/style'
import CostStateType from '../types/state/cost-state'

const useModals = (cost: CostStateType) => {
    useEffect(() => {
        if (cost.requestStatus === 'error') {
            Modal.error({
                title: 'Ошибка',
                content: <p>{cost.errorMessage}</p>,
            })
        }
    }, [cost])
}

export default useModals
